import React, { createRef, useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { API_FACTURAS_DESGUACES } from "../../../shared/services/facturas_desguaces";
import { setErrorMessage } from "../../../shared/helpers/functionalities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import ConfirmModal from "../../../shared/components/ConfirmModal";
import { useForm } from "react-hook-form";


export default function DevolucionesModal({ 
    factura,
    onSubmitDevolucion
}) {
    const dispatch = useDispatch();
    const submitBtn = createRef();
    const { register, handleSubmit, setValue } = useForm();
    const [facturaInfo, setFacturaInfo] = useState(null);
    const [refoundType, setRefoundType] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    
    useEffect(() => {
        const fetchFacturaData = async() => {
            dispatch({type: 'loading/set', payload: true});
            const response = await API_FACTURAS_DESGUACES.getFacturaById(factura.id)
            .catch(function (error) {
                toast.error(setErrorMessage(error))
                dispatch({type: 'loading/set', payload: false});
            });

            if(response && response.success) {
                dispatch({type: 'loading/set', payload: false});
                setFacturaInfo(response.data)
            }
        }

        fetchFacturaData();
    }, []);

    useEffect(() => {
        if(refoundType) {
            facturaInfo.piezas.forEach(pieza => {
                setValue(`pieza_${pieza.id}`, refoundType === 2);
            });
        }
    }, [refoundType]);

    const handleSelectType = (devolucionTypeId) => { setRefoundType(devolucionTypeId) }

    const handleOpenModal = () => setShowConfirmModal(true);
    const handleConfirmDevolucion = (confirm) => {
        if(confirm) {
            submitBtn.current.click()
        }

        setShowConfirmModal(false);
    }

    const handleSubmitDevolucion = (data, e) => {
        e.preventDefault();
        const piezas =  Object.entries(data)
            .filter(([_, value]) => value === true)
            .map(([key, _]) => key.split('_')[1])

        onSubmitDevolucion({
            tipo_factura_id: refoundType === 1 ? 2 : 3,
            piezas
        })
    }

    return (
        <div className="w-100">
            { (!refoundType) ?
                <div className="w-100 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-4 d-flex flex-column">
                        <p className="text-center fw-bold text-uppercase">Tipo de devolución</p>

                        <div className="d-flex align-items-center justify-content-center gap-4 mt-5">
                            { (factura.devoluciones?.length === 0) ?
                                <button className="btn btn-danger" onClick={() => handleSelectType(2)}>Total</button>
                                : null
                            }
                            <button className="btn btn-warning" onClick={() => handleSelectType(1)}>Parcial</button>
                        </div>
                    </div>
                </div>
                :
                <div className="w-100 mt-4">
                    <h5 className="fw-bold">Devolución {refoundType === 2 ? 'Total' : 'Parcial'}</h5>

                    <form className="form mb-4" onSubmit={handleSubmit(handleSubmitDevolucion)}>
                        <div className="w-100 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Pieza</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { facturaInfo?.piezas?.map(pieza => {
                                        return (
                                            <tr key={'devolucion-pieza-' + pieza.id}>
                                                <td className="align-middle">
                                                    <FontAwesomeIcon icon={faCogs} size="1x" color="#215732"></FontAwesomeIcon>
                                                    <span className="ms-3">
                                                        {pieza.id_referencia_plataforma} 
                                                        &nbsp;|&nbsp;
                                                        {pieza.nombre}
                                                    </span>
                                                </td>
                                                <td className="align-middle">
                                                    <div className="d-flex align-items-center">
                                                        <div className="d-flex align-items-center justify-content-between me-3">
                                                            <input 
                                                                type="checkbox"
                                                                className={refoundType === 2 ? 'disabled' : ''}
                                                                {...register("pieza_" + pieza.id)} 
                                                                readOnly={refoundType === 2 ? true : false}
                                                                defaultChecked={refoundType === 2 ? true : false} />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }) }
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex w-100 justify-content-center mt-5">
                            <button type="button" className="btn btn-primary" onClick={() => handleOpenModal()}>Crear</button>
                            <button type="submit" ref={submitBtn} className="btn btn-primary d-none"></button>
                        </div>
                    </form>
                </div>
            }

            { showConfirmModal && 
                <ConfirmModal 
                    onConfirmAction={handleConfirmDevolucion} 
                    title={`Generar devolucion ${refoundType === 2 ? 'total' : 'parcial'}`} 
                    description={'¿Estás seguro de generar la devolucion?'}
                    state={showConfirmModal}>
                </ConfirmModal>
            }
        </div>
    );
}